import styled from "styled-components";
import React from "react";

const Button = styled.a`
  margin-left: 20px;
  text-transform: none;
  font-size: 16px;
  color: #667988 !important;
  border: solid #667988 1px;
  padding-left: 15px;
  height: 36px;
  padding-top: 5px;
  padding-right: 15px;
  font-family: "Poppins", sans-serif;
  border-radius: 6px;
  position: absolute;
  bottom: 20px;
  right: 65px;
`;

const CardWrapper = styled.div`
  width: 240px;
  height: auto;
  margin-left: 7.5px;
  margin-right: 7.5px;
  margin-top: 40px;
  border-radius: 10px;
  @media only screen and (max-width: 500px) {
  }
`;

const CardImg = styled.img`
  height: 134px;
  border-top-left-radius: 8px !important;
  border-top-right-radius: 8px !important;
`;

const Card = props => (
  <CardWrapper className="card hoverable">
    <div className="card-image waves-effect waves-block waves-light">
      <CardImg className="activator" src={props.imgurl} />
    </div>
    <div
      style={{ textAlign: "center", fontSize: "24px", paddingBottom: "15px" }}
      className="card-content"
    >
      {props.data}
    </div>
    <div style={{ textAlign: "center", position: "relative", height: "70px" }}>
      <Button href="/business">Know More</Button>
    </div>
  </CardWrapper>
);

export default Card;
